module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/WAzZCg/tc-custom/9781398409408.jpg?1705056296795",
      "alt": "This image is the cover for the book Perfection Is NOT the Word for It"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Perfection Is NOT the Word for It\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Orchestral life in Britain is thriving and anarchic, in turns chaotic, hilarious and brutal. Perfection Is Not the Word for It is a personal, and mostly affectionate, account of life amongst the extraordinary characters who lead their over-stressed lives in this unusual world, surrounded by music but driven by everyday anxieties, and always defying the best efforts of administrators, bureaucrats and conductors to tame the unruly beast which is a professional orchestra.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Felix Warnock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Felix Warnock spent fifteen years as a freelance bassoon player based in London, but frequently on tour around the world. He was a founder member of the Orchestra of the Age of Enlightenment, becoming its chief executive in 1988. He spent a further fifteen years as manager of The English Concert. He taught bassoon at Trinity College of Music, was briefly Head of Early Music at the Royal Academy of Music and was chairman of The Radcliffe Trust until 2019. He lives in London and now works in mental health research, a field in which he is eminently qualified after a career in the orchestral world.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0